class CollectionListCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-clc-track]');
    this.prevBtn = root.querySelector('[data-clc-prev]');
    this.nextBtn = root.querySelector('[data-clc-next]');
    this.countEl = root.querySelector('[data-clc-count]');
    if (!this.track) return;

    this.cardsPerView = parseInt(
      getComputedStyle(root).getPropertyValue('--clc-cards-per-view')
    ) || 4;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.page(-1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.page(1));
    this.track.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => this.updateState());
    });
    window.addEventListener('resize', () => this.updateState());

    this.updateState();
  }

  // width of one full "page" = cardsPerView cards + gaps, i.e. the track's own visible width
  pageWidth() {
    return this.track.clientWidth;
  }

  page(direction) {
    this.track.scrollBy({ left: direction * this.pageWidth(), behavior: 'smooth' });
  }

  updateState() {
    const cards = this.track.querySelectorAll('.clc-card');
    const total = cards.length;
    const perView = Math.min(this.cardsPerView, total) || 1;
    const totalPages = Math.max(Math.ceil(total / perView), 1);
    const currentPage = Math.round(this.track.scrollLeft / this.pageWidth()) + 1;

    if (this.countEl) {
      this.countEl.textContent =
        String(Math.min(currentPage, totalPages)).padStart(2, '0') +
        ' / ' +
        String(totalPages).padStart(2, '0');
    }

    if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 4;
    if (this.nextBtn) {
      this.nextBtn.disabled =
        this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
    }
  }
}

document.querySelectorAll('.clc-section').forEach((section) => {
  new CollectionListCarousel(section);
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.clc-section');
  if (section) new CollectionListCarousel(section);
});